import { makeMultiSorter } from 'components/table';

import { PreparedWorkload } from 'features/workload-optimization';

export const PodsSorter = makeMultiSorter({
  sortBy: [
    {
      name: 'Current pod count',
      accessor: 'podCount',
      testId: 'current',
    },
    {
      name: 'Desired pod count',
      accessor: 'replicas',
      testId: 'desired',
    },
  ],
});

export const RecommendedSorter = makeMultiSorter({
  sortBy: [
    {
      name: 'CPU',
      accessor: (d: PreparedWorkload) => d.cpu.recommended || 0,
      testId: 'cpu-recommended',
    },
    {
      name: 'Memory',
      accessor: (d: PreparedWorkload) => d.memory.recommended || 0,
      testId: 'memory-recommended',
    },
  ],
});
